export default __webpack_public_path__ + "static/media/gallery_05.1691ae30.jpg";